/**
 * 负责提供返回的数据   要数据先过我这关
 */
export const comics = state => state.comics
export const chapter = state => state.chapter
export const param = state => state.param
export const user = state => state.user
export const isShow = state => state.isShow
export const postlist = state => state.postlist
export const currentPage = state => state.currentPage
export const count = state => state.count
// export const currentSong = (state) => {
//   return state.playlist[state.currentIndex] || {}
// }



// WEBPACK FOOTER //
// ./src/store/getters.js